import axios from '@axios'

const PREFIX = '/usuarios-externos'

export default {

  getUsuariosExternos(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getUsuarioExterno(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  updateUsuarioExterno(id, usuarioExt) {
    return axios.put(`${PREFIX}/${id}`, usuarioExt)
  },

  createUsuarioExterno(usuarioExt) {
    return axios.post(`${PREFIX}/add`, usuarioExt)
  },

  deleteUsuarioExterno(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  existeInscricao(id, inscricao) {
    if (id) {
      return axios.get(`${PREFIX}/${id}/inscricao/${inscricao}`)
    }
    return axios.get(`${PREFIX}/inscricao/${inscricao}`)
  },

  existeEmail(id, email) {
    if (id) {
      return axios.get(`${PREFIX}/${id}/email/${email}`)
    }
    return axios.get(`${PREFIX}/email/${email}`)
  },

  existeLogin(id, emailUsuario) {
    if (id) {
      return axios.get(`${PREFIX}/${id}/login/${emailUsuario}`)
    }
    return axios.get(`${PREFIX}/login/${emailUsuario}`)
  },

  getUsuariosResumidos(filtro) {
    return axios.post(`${PREFIX}/resumido`, filtro)
  },

  getSociosResumidos() {
    return axios.get(`${PREFIX}/socio-resumido`)
  },

  existeCobrancaEmpresa(contatoId, empresaId) {
    return axios.get(`${PREFIX}/${contatoId}/existe-cobranca/${empresaId}`)
  },

  conviteAcesso(id) {
    return axios.get(`${PREFIX}/convite-acesso/${id}`)
  },

  existeResponsavelRFB(id) {
    return axios.get(`${PREFIX}/existe-rfb/${id}`)
  },

  existeVinculoSocio(empresaId, usuarioId) {
    return axios.get(`${PREFIX}/existe-vinculo-socio/${usuarioId}/empresa/${empresaId}`)
  },

  getArquivoUsuario(id) {
    return axios.get(`${PREFIX}/${id}/arquivo`)
  },
}
